import { Translate } from 'next-translate'

export const getTranslatedStateOfMaintenance = (stateOfMaintenance: string, t: Translate) => {
  if (stateOfMaintenance.toLocaleLowerCase() === 'fully_renovated') return t('common:renovated')
  return t(`common:${stateOfMaintenance.toLocaleLowerCase()}`)
}
